import { isPlatformRequestError } from "./isPlatformRequestError.ts";
import type { RequestValidationFailedError } from "./types.ts";

export function isRequestValidationFailedError(
  err: unknown,
): err is RequestValidationFailedError {
  return isPlatformRequestError(
    err,
    400,
    "BadRequest",
    "RequestValidationFailed",
  );
}
